module.exports = __webpack_public_path__ + "img/my.f1cd5cad.svg";